/**
 * Request-scoped session state shared by HTTP layer + storage service.
 * Kept out of service classes so it can be reset in tests.
 */
let selectedGroupId = null
let abortController = new AbortController()

export function getSelectedGroupId() {
  return selectedGroupId
}

export function setSelectedGroupId(id) {
  selectedGroupId = id ?? null
}

export function getAbortController() {
  return abortController
}

/** Replace the controller (e.g. after canceling a batch of requests). */
export function resetAbortController() {
  try {
    abortController.abort()
  } catch (_) { /* ignore */ }
  abortController = new AbortController()
  return abortController
}
